// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"tm_a big_b big_bj","StrollerbaseBanner__hint":"tm_b big_vh","StrollerbaseBanner__link":"tm_c"};